import {  createContext } from 'react'
import type {ReactNode} from 'react';

interface AppLayoutContextType {
  secSidebar: ReactNode | null
  setSecSidebar: (content: ReactNode | null) => void
  sidebarWidth: number
  setSidebarWidth: (width: number) => void
  headerHeight: number
  showHeader: boolean
  setShowHeader: (show: boolean) => void
  breadcrumb: ReactNode | null
  setBreadcrumb: (content: ReactNode | null) => void
  breadcrumbActions: ReactNode | null
  setBreadcrumbActions: (content: ReactNode | null) => void
  openSearch: () => void
  openAskWorkspace: () => void
}

// Create the context with undefined as a valid initial value
export const AppLayoutContext = createContext<AppLayoutContextType | undefined>(
  undefined,
)
